<template>
  <div id="app">
    <Header :class="{'home-header':$route.path==='/'}"></Header>
    <router-view/>
    <Footer v-if="!$route.path.includes('/doc')"></Footer>
  </div>
</template>
<script>
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";

  export default {
    components: {
      Header,
      Footer
    },
    created() {

    },
  };
</script>
<style lang="scss">
  * {
    margin: 0;
    padding: 0;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: hsla(220, 4%, 58%, 0.3);
  }

  a {
    color: #3e63f9;
    background-color: transparent;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .btn {
    padding: 0;
  }
</style>
